export default "__VITE_ASSET__CFtaS7XP__"